
function initArcMagic () {

    TweenMax.to(".overlay svg", 2, {
        opacity: 0,
        y: -60,
        ease: Expo.easeInOut
    })

    TweenMax.to(".overlay", 2, {
        delay: 1,
        top: "-100%",
        ease: Expo.easeInOut
    })

// Scrollmagic
    var controllerColor = new ScrollMagic.Controller({
        globalSceneOptions: {}
    });

// Colors
    new ScrollMagic.Scene({
        triggerElement: ".arc-page__green",
        duration: "100%"

    })
        .setClassToggle(".arc-page", "color-green") // add class toggle
        .addTo(controllerColor);
    new ScrollMagic.Scene({
        triggerElement: ".arc-page__black",
        duration: 900

    })
        .setClassToggle(".arc-page", "color-black") // add class toggle
        .addTo(controllerColor);
    new ScrollMagic.Scene({
        triggerElement: ".arc-page__about-us",
        duration: "100%"


    })
        .setClassToggle(".arc-page", "color-light-green") // add class toggle
        .addTo(controllerColor);
    new ScrollMagic.Scene({
        triggerElement: ".arc-page__work",
        duration: "100%"

    })
        .setClassToggle(".arc-page", "color-black") // add class toggle
        .addTo(controllerColor);
    new ScrollMagic.Scene({
        triggerElement: ".arc-page__contact",
        duration: "100%"

    })
        .setClassToggle(".arc-page", "color-green") // add class toggle
        .addTo(controllerColor);


// Breaker one
    var scrollWords = new TimelineMax({});

    var controller = new ScrollMagic.Controller({
        globalSceneOptions: {}
    });

    scrollWords
        .to('.arc-is__section .arc-is__rolling-container', {y: "-75%", duration: 4, ease: "none"})
        .to('.arc-is__section .arc-is__design', {scale: 0.9, opacity: 0.5, duration: 1, ease: "power2.inOut"}, "-=4")
        .to('.arc-is__section .arc-is__tech', {scale: 1, opacity: 1, duration: 1, ease: "power2.inOut"}, "-=4")
        .to('.arc-is__section .arc-is__tech', {scale: 0.9, opacity: 0.5, duration: 1, ease: "power2.inOut"}, "-=3")
        .to('.arc-is__section .arc-is__data', {scale: 1, opacity: 1, duration: 1, ease: "power2.inOut"}, "-=2.5")
        .to('.arc-is__section .arc-is__data', {scale: 0.9, opacity: 0.5, duration: 1, ease: "power2.inOut"}, "-=1.5")
        .to('.arc-is__section .arc-is__delivery', {scale: 1, opacity: 1, duration: 1, ease: "power2.inOut"}, "-=1")
        .to('.arc-is__section .arc-is__delivery', {opacity: 1, duration: 1, ease: "none"})
        .to('.arc-is__section .arc-is__delivery', {opacity: 1, duration: 0.1, ease: "none"}, "+=2");

    const sceneBreakerOne = new ScrollMagic.Scene({
        triggerElement: ".arc-page__black",
        triggerHook: "onLeave",
        duration: 1000
    })
        .setPin(".arc-page__black")
        .setTween(scrollWords)
        .addTo(controller);


    if (window.matchMedia('(max-width: 768px)').matches) {
        controller.destroy(scrollWords);
        controllerMobile = new ScrollMagic.Controller({
            globalSceneOptions: {}
        });

        var scrollWordsMobile = new TimelineMax({});


        scrollWordsMobile
            .to('.arc-is__section .arc-is__rolling-container', {y: "-75%", duration: 4, ease: "none"})
            .to('.arc-is__section .arc-is__design', {scale: 0.9, opacity: 0, duration: 1, ease: "power2.inOut"}, "-=4")
            .to('.arc-is__section .arc-is__tech', {scale: 1, opacity: 1, duration: 1, ease: "power2.inOut"}, "-=4")
            .to('.arc-is__section .arc-is__tech', {scale: 0.9, opacity: 0, duration: 1, ease: "power2.inOut"}, "-=3")
            .to('.arc-is__section .arc-is__data', {scale: 1, opacity: 1, duration: 1, ease: "power2.inOut"}, "-=2.5")
            .to('.arc-is__section .arc-is__data', {scale: 0.9, opacity: 0, duration: 1, ease: "power2.inOut"}, "-=1.5")
            .to('.arc-is__section .arc-is__delivery', {scale: 1, opacity: 1, duration: 1, ease: "power2.inOut"}, "-=1")
            .to('.arc-is__section .arc-is__delivery', {opacity: 1, duration: 1, ease: "none"})
            .to('.arc-is__section .arc-is__delivery', {opacity: 1, duration: 0.1, ease: "none"}, "+=2");

        const sceneBreakerOneMobile = new ScrollMagic.Scene({
            triggerElement: ".arc-page__black",
            triggerHook: "onLeave",
            duration: 1000
        })
            .setPin(".arc-page__black")
            .setTween(scrollWordsMobile)
            .addTo(controllerMobile);


    }
}
if (jQuery(".arc-page").length > 0) {
    initArcMagic();
}
